import { Component } from 'react';
import { connect } from 'react-redux';
import { RouteConstants } from "../route/services/RouteConstants";
import { getLanguage, getSecurityQuestions, isEnglishActive } from "../../store/rootReducer";
import HrbTranslate from '../language/HrbTranslate';
import logo from '../../assets/images/hrb-logo-horizontal.svg';
import dict from '../../resources/data/dict.json';
import _find from 'lodash/find';
import './UpdateEmailSecurity.scss';
import api from '../../services/api/AccountUpdateApi';
import { ErrorCodes, ErrorMessages } from '../../configurations/ErrorConstants';
import { HeapEvents, trackEvent } from '../../services/util/AnalyticsUtil';

class UpdateEmailSecurity extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
      securityAnswer: '',
      isSubmitting: false,
      isAccountLocked: false,
      securityAnswerError: null
    };
  }

  componentDidMount() {
    if (!this.props.location.state || !this.props.location.state.username) {
      this.props.history.push(RouteConstants.UPDATE_EMAIL);
    }
  }

  getSecurityQuestion = () => {
    const securityQuestionId = this.props.location.state?.securityQuestionId;
    if (!securityQuestionId) {
      return "";
    }

    const question = _find(this.props.securityQuestions, { 'id': securityQuestionId });
    if (!question) {
      return "";
    }

    return this.props.isEnglishActive ? question.en : question.fr;
  };

  handleSecurityAnswerChange = (e) => {
    this.setState({ 
      securityAnswer: e.target.value,
      errorMessage: null,
      securityAnswerError: null
    });
  };

  handleSecurityAnswerBlur = () => {
    this.setState({ securityAnswerError: null, errorMessage: null });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.submitSecurityForm();
  };

  submitSecurityForm = async () => {
    this.setState({ 
      errorMessage: null,
      securityAnswerError: null
    });

    if (!this.state.securityAnswer || this.state.securityAnswer.trim() === '') {
      this.setState({ securityAnswerError: 'error_answer_empty' });
      return;
    }

    trackEvent(HeapEvents.ACCONT_RECOVERY_SUBMITTED_SECURITY_ANSWER);
    
    this.setState({ isSubmitting: true });

    const { username, token, securityQuestionId } = this.props.location.state;

    var request = {
      username,
      password: null,
      securityQuestionId,
      securityAnswer: this.state.securityAnswer,
      token
    };

    var response = await api.verifyUserAsync(request);
    
    if(response.errorCode) {
      if(response.errorCode === ErrorCodes.INVALID_CREDENTIALS) {
        this.setState({ 
          errorMessage: ErrorMessages.INVALID_CREDENTIALS,
          isSubmitting: false
        });
      } else if(response.errorCode === ErrorCodes.ACCOUNT_LOCKED) {
        this.setState({ 
          errorMessage: ErrorMessages.ACCOUNT_LOCKED,
          isAccountLocked: true,
          isSubmitting: false
        });
      } else {
        this.setState({ 
          errorMessage: ErrorMessages.INVALID_CREDENTIALS,
          isSubmitting: false
        });
      }
      return;
    }

    if(response.token) {
      this.props.history.push({
        pathname: RouteConstants.UPDATE_EMAIL_NEW,
        state: { 
          username,
          token: response.token
        }
      });
    }
  };

  render() {
    const { language } = this.props;
    const lang = language ? language.toLowerCase() : 'en';
    const securityQuestionText = this.getSecurityQuestion();
    
    return (
      <div className="hrb-update-email-security-card">
        <div className="hrb-update-email-security-logo">
          <img src={logo} alt="H&R Block" />
        </div>

        <h1 className="hrb-update-email-security-title">
          <HrbTranslate text="update_email.security.mobile_title" />
        </h1>

        <p className="hrb-update-email-security-intro">
          <HrbTranslate text="update_email.security.intro" />
        </p>

        {this.state.errorMessage && (
          <div className="hrb-update-email-security-error">
            <HrbTranslate text={`update_email.start.${this.state.errorMessage}`} />
          </div>
        )}

        {!this.state.isAccountLocked && (
          <>
            <div className="hrb-update-email-security-form">
              <label className="hrb-update-email-security-question">
                {securityQuestionText}
              </label>

              <div className="hrb-update-email-security-input-group">
                <div className={`hrb-update-email-security-input-wrapper ${this.state.securityAnswerError ? 'has-error' : ''}`}>
                  <input
                    type="text"
                    className="hrb-update-email-security-input"
                    placeholder={dict.update_email.security.answer_field_label[language.toLowerCase()]}
                    value={this.state.securityAnswer}
                    onChange={this.handleSecurityAnswerChange}
                    onBlur={this.handleSecurityAnswerBlur}
                  />
                </div>
                {this.state.securityAnswerError && (
                  <div className="hrb-update-email-security-field-error">
                    <HrbTranslate text={`update_email.security.${this.state.securityAnswerError}`} />
                  </div>
                )}
              </div>
            </div>

            <div className="hrb-update-email-security-actions">
              <button
                className="hrb-update-email-security-button"
                onClick={this.submitSecurityForm}
                disabled={this.state.isSubmitting}
              >
                <HrbTranslate text="update_email.security.continue" />
              </button>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state),
    isEnglishActive: isEnglishActive(state),
    securityQuestions: getSecurityQuestions(state)
  };
};

export default connect(mapStateToProps)(UpdateEmailSecurity);
